import React, { useState, useEffect } from "react";
import {
  AdminContentContainer,
  AdminContentTitle,
  NoResults,
  ScrollableList,
  Card,
  CardContent,
  CardText,
  ActionButtons,
  ActionButton,
} from '../styles';
import { Spinner } from ".";
import { adminGetBlockedUsers, adminUnblockBlockedUsers, adminDeleteBlockedUsers } from "../api";

const ProfessorApproval = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleUnblock = async (userId) => {
    try {
      const response = await adminUnblockBlockedUsers(userId);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erro ao desbloquear usuário');
      }

      setBlockedUsers(blockedUsers.filter((user) => user.id !== userId));

    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (userId) => {
    try {
      const response = await adminDeleteBlockedUsers(userId);

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erro ao excluir usuário bloqueado');
      }

      setBlockedUsers(blockedUsers.filter((user) => user.id !== userId));

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchBlockedUsers = async () => {
      try {
        setLoading(true);

        const response = await adminGetBlockedUsers();

        const data = await response.json();

        if (!response.ok) throw new Error(data.message || 'Erro ao buscar usuários bloqueados');
        
        setBlockedUsers(data.blockedUsers);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlockedUsers();
  }, []);

  const formatCNPJ = (cnpj) => cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');

  const formatCPF = (cpf) => cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');

  return (
    <AdminContentContainer>
      <AdminContentTitle>Usuários Bloqueados</AdminContentTitle>
      {loading ? (
        <Spinner />
      ) : (
        blockedUsers.length === 0 ? (
          <NoResults>Não há aprovações pendentes</NoResults>
        ) : (
          <ScrollableList>
            {blockedUsers.map((user) => (
              <Card key={user.id}>
                <CardContent>
                  <CardText><strong>Nome:</strong> {user.fullName}</CardText>
                  <CardText><strong>Username:</strong> {user.username}</CardText>
                  <CardText><strong>CNPJ:</strong> {formatCNPJ(user.cnpj)}</CardText>
                  <CardText><strong>CPF:</strong> {formatCPF(user.cpf)}</CardText>
                  <ActionButtons>
                    <ActionButton style={{ backgroundColor: '#4CAF50', color: '#fff' }} onClick={() => handleUnblock(user.id)}>
                      Permitir
                    </ActionButton>
                    <ActionButton style={{ backgroundColor: '#FF4D4D', color: '#fff' }} onClick={() => handleDelete(user.id)}>
                      Não Permitir
                    </ActionButton>
                  </ActionButtons>
                </CardContent>
              </Card>
            ))}
          </ScrollableList>
        )
      )}
    </AdminContentContainer>
  );
};

export default ProfessorApproval;
